<div class="noselect">
  <div class="d-flex">
    <ng-container>
      <div (click)="$event.stopPropagation()">
        <button class="op-btn-count-control btn-primary-themed"
                [disabled]="minusDisablingCheck()"
                (click)="$event.stopPropagation(); shiftCount(false)">
          <i class="icon-minus op-counter-control"></i>
        </button>
      </div>

      <div class="count text-center fw-bold"
           *ngIf="!isAllowEnterCounter">
        {{count}}
      </div>

      <input class="count input-counter text-center fw-bold"
             type="number"
             *ngIf="isAllowEnterCounter"
             [min]="minCount"
             [max]="maxCount"
             [pattern]="positiveNumberPattern"
             (click)="$event.stopPropagation()"
             [(ngModel)]="count"
             (ngModelChange)="countChange$.next(+$event)">
    </ng-container>

    <button class="op-btn-count-control btn-primary-themed"
            [disabled]="plusDisablingCheck() || isPlusDisabled"
            (click)="$event.stopPropagation(); shiftCount(true)">
      <i class="icon-plus op-counter-control"></i>
    </button>
  </div>
</div>
